// Translated from Ruby backend validator: components/payroll_employees/app/services/payroll_employees/validators/portugal_tax_id.rb

const TAX_ID_LENGTH = 9
const TAX_ID_REGEX = /^\d{9}$/
const VALIDATION_SET = {
  one: ['1', '2', '3', '5', '6', '8'],
  two: ['45', '70', '71', '72', '74', '75', '77', '79', '90', '91', '98', '99'],
}

const isValidFirstDigits = (taxId: string): boolean => {
  const firstDigit = taxId[0] || ''
  const firstTwoDigits = taxId.substring(0, 2)

  return VALIDATION_SET.one.includes(firstDigit) || VALIDATION_SET.two.includes(firstTwoDigits)
}

const isValidControlDigit = (taxId: string): boolean => {
  const digits = taxId.split('').map(Number)

  // Calculate sum with weights (9-n for positions 0-7)
  let sum = 0
  for (let n = 0; n <= 7; n++) {
    sum += (digits[n] || 0) * (9 - n)
  }

  const mod = sum % 11
  const expectedCheckDigit = mod < 2 ? 0 : 11 - mod

  return (digits[8] || 0) === expectedCheckDigit
}

const validatePortugalTaxId = (taxId: string): boolean => {
  if (!taxId || taxId.length !== TAX_ID_LENGTH) {
    return false
  }

  if (!TAX_ID_REGEX.test(taxId)) {
    return false
  }

  return isValidFirstDigits(taxId) && isValidControlDigit(taxId)
}

export default validatePortugalTaxId
